import getMuiTheme from "material-ui/styles/getMuiTheme";

const muiTheme = getMuiTheme({
	palette: { primary1Color: "#1872e0" },
	fontFamily: "Lato",
	tabs: {
		backgroundColor: "rgb(255, 255, 255)",
		textColor: "#636363",
		selectedTextColor: "rgb(0, 0, 0)",
	},
});

export default muiTheme;



// WEBPACK FOOTER //
// ./src/utils/mui_theme.ts